module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp12_9016.bc4b927a.png";